import eBillHomeApi from '@/api/eBillHome/eBillHomeApi.js';

export default {
	name: 'e-bill-home',
	mixins: [],
	extends: {},
	components: {},
	props: [],
	data() {
		return {
			type:null
		};
	},
	computed: {

	},
	watch: {},
	created() {
	},
	mounted() {
        this.getEBType();
    },
	updated() {},
	beforeDestroy() {},
	methods: {
        async getEBType(){
			let eBType = await eBillHomeApi.getEBType();
			if(eBType){
				this.type = eBType.ebType;
			}

        }
    },
};



// WEBPACK FOOTER //
// ./src/components/eBill/eBillHome.js